<select name="" id="" [formControl]="formControl">
  <option [value]="option" *ngFor="let option of params.values">{{option}}</option>
</select>